import { Component, Input } from '@angular/core';
import { QualificationCallOverviewModel } from 'models/generated/Models.QualificationCallOverview';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserPipe } from 'pipes/user.pipe';
import { UserService } from 'services/user.service';

@Component({
	selector: 'blocklist-qualification-call',
	templateUrl: './blocklist-qualification-call.component.html',
	styleUrls: ['./blocklist-qualification-call.component.scss'],
	imports: [CurrencyPipe, TranslatePipe, CustomDatePipe, UserPipe]
})
export class BlockListQualificationCallComponent {

	@Input() qualificationCall!: QualificationCallOverviewModel;

	constructor(private readonly userService: UserService) { }

	getTeamShortName(teamId?: string): string {
		const team = this.userService.team(teamId);
		if (team && team.name.length >= 3) {
			return team.name.substr(0, 3).toUpperCase();
		}
		return '';
	}
}
